export enum TokenExchangeOutput {
    Endpoint = "endpoint",
    MagicKey = "magicKey"
}
